import { render } from "./App.vue?vue&type=template&id=42582f45"
const script = {}

import "./App.vue?vue&type=style&index=0&id=42582f45&lang=css"

import exportComponent from "E:\\工作\\前端代码\\康庭后台\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__